define('views/components/product_reseller_price/product_reseller_price',['require','backbone','text!templates/components/product_reseller_price/product_reseller_price.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/product_reseller_price/product_reseller_price.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),
        className: 'product-price-item',

        ui: function() {
            return {
                priceInput: 'input.price-input'
            };
        },

        events: {
            'change @ui.priceInput': 'priceInputChanged'
        },

        priceInputChanged: function () {
            this.model.set('price', this.ui.priceInput.val());
            this.model.updated = true;
        }
    });
});
